import React, { useState, useEffect } from "react";
import { supabase } from "../../../../supabaseClient.jsx";
import { Heart } from "lucide-react";
import { cn } from "../../../../design-system/index.js";

const defaultContent = {
  sobre_nos_p1:
    "Somos uma agência de babás moderna, transparente e focada em facilitar a vida das famílias. Com tecnologia, agilidade e muito cuidado, conectamos você às melhores profissionais da área, através dos nossos pacotes e assinatura dos nossos serviços.",
  sobre_nos_p2:
    "Sou Carla Corrêa, fundadora do Tesourinho's, com 10 anos de experiência como Baby-Sitter. Já atendi mais de 100 famílias e venho expandir minha experiência através deste site, facilitando a organização das famílias e proporcionando um atendimento diferenciado.",
  sobre_nos_p3: "Seus tesourinhos estarão em boas mãos! Bem-vindos!",
};

const AboutUsSection = () => {
  const [content, setContent] = useState(defaultContent);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const { data, error } = await supabase.from("site_content").select("*");
        if (!error && data) {
          const map = data.reduce((acc, item) => {
            if (item.key.startsWith("sobre_nos")) acc[item.key] = item.content;
            return acc;
          }, {});
          setContent((prev) => ({ ...prev, ...map }));
        }
      } catch {}
      finally { setLoading(false); }
    };
    fetchContent();
  }, []);

  return (
    <section id="sobre-nos" className="bg-white py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">

          {/* Imagem */}
          <div className="relative order-2 md:order-1">
            <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-[var(--color-rose-400)/10] to-[var(--color-slate-blue-400)/10] blur-xl" />
            <img
              src="/assets/caca-executiva.jpeg"
              alt="Sobre nós — Tesourinhos"
              className="relative z-10 w-full rounded-3xl object-cover shadow-lg"
            />
          </div>

          {/* Texto */}
          <div className="order-1 md:order-2">
            <div className="flex items-center gap-2 mb-4">
              <Heart size={18} className="text-[var(--color-rose-400)] fill-[var(--color-rose-400)]" />
              <span className="text-sm font-semibold text-[var(--color-rose-400)] uppercase tracking-wide">
                Nossa história
              </span>
            </div>

            <h2 className={cn(
              "font-heading text-3xl sm:text-4xl font-bold",
              "text-[var(--color-warm-900)] mb-6"
            )}>
              Sobre Nós
            </h2>

            {loading ? (
              <div className="space-y-3">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="h-4 rounded-full bg-[var(--color-warm-100)] animate-pulse" style={{ width: `${90 - i * 10}%` }} />
                ))}
              </div>
            ) : (
              <div className="space-y-4 text-[var(--color-warm-600)] text-sm sm:text-base leading-relaxed">
                <p>{content.sobre_nos_p1}</p>
                <p>{content.sobre_nos_p2}</p>
                <p className="font-semibold text-[var(--color-warm-800)]">{content.sobre_nos_p3}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;